"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteApplicationForm = exports.updateApplicationForm = exports.getApplicationFormDetail = exports.createApplicationForm = exports.getApplicationForms = void 0;
var core_1 = __importDefault(require("@/api/core"));
var getApplicationForms = function (params) {
    return core_1.default.get({
        url: '/application-forms',
        params: params,
    });
};
exports.getApplicationForms = getApplicationForms;
var createApplicationForm = function (data) {
    return core_1.default.post({
        url: '/application-forms',
        data: data,
    });
};
exports.createApplicationForm = createApplicationForm;
var getApplicationFormDetail = function (applicationFormId) {
    return core_1.default.get({ url: "/application-forms/".concat(applicationFormId) });
};
exports.getApplicationFormDetail = getApplicationFormDetail;
var updateApplicationForm = function (applicationFormId, data) {
    return core_1.default.put({
        url: "/application-forms/".concat(applicationFormId),
        data: data,
    });
};
exports.updateApplicationForm = updateApplicationForm;
var deleteApplicationForm = function (applicationFormId) {
    return core_1.default.delete({
        url: "/application-forms/".concat(applicationFormId),
    });
};
exports.deleteApplicationForm = deleteApplicationForm;
